import { render, staticRenderFns } from "./SelectSprachkenntnisseScala.vue?vue&type=template&id=acc5be20"
import script from "./SelectSprachkenntnisseScala.vue?vue&type=script&lang=js"
export * from "./SelectSprachkenntnisseScala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports